import { render } from "./TheOnlineServices.vue?vue&type=template&id=4f611d4c&scoped=true&ts=true"
import script from "./TheOnlineServices.vue?vue&type=script&lang=ts"
export * from "./TheOnlineServices.vue?vue&type=script&lang=ts"

import "./TheOnlineServices.vue?vue&type=style&index=0&id=4f611d4c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f611d4c"]])

export default __exports__